import pt from 'date-fns/locale/pt';
import { registerLocale } from 'react-datepicker';
import { Config } from '../../common/types/config';

const envConfig: any = process.env.ENV_CONFIG;

// if (envConfig.UseIFrameLogic) {
//    document.domain = 'bmw.pt';
// }

const appEnvConfig = ({
    'local-bmw': require('./Config.local'),
    'local-mini': require('./Config.local'),
    'development-bmw': require('./Config.development'),
    'development-mini': require('./Config.development'),
    'quality-bmw': require('./Config.quality'),
    'quality-mini': require('./Config.quality'),
    'production-bmw': require('./Config.production'),
    'production-mini': require('./Config.production'),
} as any)[envConfig.AppEnv || 'development-bmw'].default;

const DevAppEnvs = ['development-bmw', 'development-mini', 'local-bmw', 'local-mini'];

// const ReportGeralConst = 'REPORT_GERAL';
// const ReportTSPConst = 'REPORT_TSP';
// const ReportCICConst = 'REPORT_CIC';
// const ReportAnaliseConst = 'REPORT_ANALISE';

// export interface ReportTypeDefinition {
//     type: string;
//     title: string;
//     apiAction: string;
//     fileExtension: string;
// }

export interface PrimeConfig {
    UseAuthCookie: boolean; // true: a cookie for storing the access token, otherwise use the session storage
    ATCookieTimeToLive: number;
    ATCookieSameSite: boolean;
    LegalNoticeURL: string;
    IframeId: string;
    UseIFrameLogic: boolean;
    EnableVehicleValidation: boolean;
    JwtSecret: string;
    RegisterType_Default: string;
    RegisterType_OldUsers: string;
    RegisterType_Offers: string;
    CosyImagesPath: string;
    ScriptsPath: string;
    EpaasSrc: string;
    EpaasTenant: string;
    EpaasLocale: string;
    VCPackagesImagesPath: string;
    SubscrPlanitemsImagesPath: string;
    RegisterType_ValueCare: string;
    RegisterType_MiniRegeneration: string;
    PrivacyStatementURL: string;
    DevAppEnvs: string[];
    NotFoundURL: string;
    DateLocale: string;
    DateMask: string;
    DateTimeMask: string;
    TimeHourMask: string;
    TimeHourToSecondMask: string;
    MinDate: Date;
    MaxDate: Date;
    Styles: {
        PrimaryColor: string;
        Primary2Color: string;
        SecondaryColor: string;
        TextColor: string;
        AlternateTextColor: string;
    };
    Constants: {
        RoleTypes: {
            SystemAdmin: string;
        },
        Regex: {
            NumbersOnlyValidation: RegExp;
            EmailValidation: RegExp;
            LicensePlateValidation: RegExp;
            PostalCodeValidation: RegExp;
            PasswordValidation: RegExp;
            VinValidation: RegExp;
            HtmlInjectionValidation: RegExp;
        },
        ErrorCodes: {
            UnknownError: string;
            SessionExpired: string;
            AuthenticationFailed: string;
            InvalidUsernameOrPassword: string;
        },
        UsageTextType: {
            Header: number,
            BeforeUsageDef: number,
            AfterUsageDef: number,
            Popup: number,
            Footer: number,
        },
        ReactableDefaultItemsPerPage: number;
        ReactablePageButtonLimit: number;
    };
    Validations: {
        FirstName: { MaxLength: number };
        LastName: { MaxLength: number };
        City: { MaxLength: number };
        AddressFloor: { MaxLength: number };
        AddressNumber: { MaxLength: number };
        AddressStreet: { MaxLength: number };
        PostalCode: { MaxLength: number };
        Nif: { MaxLength: number };
        PhoneNumber: { MaxLength: number };
        VIN: { MaxLength: number };
        LicensePlate: { MaxLength: number };
        LicensePlateForeign: { MaxLength: number };
    };
    isDevAppEnv: boolean;
    BrandEnv: string;
    Show_vc_card: boolean;
    Show_vc_packs: boolean;
    Show_valueRepair: boolean;
    Show_bemvindo: boolean;
    Show_maintenance_packs: boolean;
    Show_subscriptions: boolean;
    Show_contractsinvoices: boolean;
    Show_offers: boolean;
    Show_serviceSchedule: boolean;
    Show_recallAndTAs: boolean;
    Show_tyresSimulator: boolean;
    Show_eventos: boolean;
    Show_Cards: boolean;
    Show_addBefore2013: boolean;
}

const config: Config & PrimeConfig = {
    ...Object.assign(
        envConfig,
        {
            //
            DevAppEnvs,
            //
            IframeId: 'iframepar__iframeadaptive',
            UseIFrameLogic: envConfig.UseIFrameLogic,
            EnableVehicleValidation: envConfig.EnableVehicleValidation,
            JwtSecret: envConfig.JwtSecret,
            RegisterType_Default: 'default,',
            RegisterType_OldUsers: envConfig.RegisterType_OldUsers,
            RegisterType_Offers: envConfig.RegisterType_Offers,
            CosyImagesPath: envConfig.CosyImagesPath,
            ScriptsPath: envConfig.ScriptsPath,
            EpaasSrc: envConfig.EpaasSrc,
            EpaasTenant: envConfig.EpaasTenant,
            EpaasLocale: envConfig.EpaasLocale,
            VCPackagesImagesPath: envConfig.VCPackagesImagesPath,
            SubscrPlanitemsImagesPath: envConfig.SubscrPlanitemsImagesPath,
            RegisterType_ValueCare: envConfig.RegisterType_ValueCare,
            RegisterType_MiniRegeneration: envConfig.RegisterType_MiniRegeneration,
            LegalNoticeURL: envConfig.LegalNoticeURL,
            PrivacyStatementURL: envConfig.PrivacyStatementURL,
            NotFoundURL: `${envConfig.BaseURL}/notfound`,
            DateLocale: 'pt',
            DateMask: 'dd/MM/yyyy',
            DateTimeMask: 'dd/mm/yyyy HH:MM:ss',
            TimeHourMask: 'HH:mm',
            TimeHourToSecondMask: 'HH:mm:ss',
            MinDate: new Date(1900, 0, 1),
            MaxDate: new Date(2100, 0, 1),
            //
            // Styles: {
            //    PrimaryColor: '#2D68FF',
            //    Primary2Color: '#1b58f3',
            //    SecondaryColor: '#0E356A',
            //    TextColor: '#000',
            //    AlternateTextColor: '#333',
            // },
            Constants: {
                RoleTypes: {
                    SystemAdmin: 'system_admin',
                },
                CortesiasComerciais: {
                    EstadosPedido: {
                        PedidoCriado: 0,
                        PedidoSubmetidoAoGestor: 1,
                        PedidoSubmetido: 2,
                        PedidoEmAnalise: 3,
                        PedidoAprovado: 4,
                        PedidoEmEspera: 5,
                        PedidoReprovado: 6,
                        PedidoFinalizado: 7,
                        PedidoBloqueado: 8,
                    },
                    Documents: {
                        Limit: 10,
                    },
                },
                Regex: {
                    NumbersOnlyValidation: /^[0-9\b]+$/,
                    EmailValidation: /^(?!.*\.{2})[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,3}$/,
                    LicensePlateValidation: /^[0-9]{2}-[0-9]{2}-[A-Z]{2}$|^[0-9]{2}-[A-Z]{2}-[0-9]{2}$|^[A-Z]{2}-[0-9]{2}-[0-9]{2}$|^[A-Z]{2}-[0-9]{2}-[A-Z]{2}$/,
                    PostalCodeValidation: /^[0-9]{4}-[0-9]{3}$/,
                    PasswordValidation: /^(?=.*[a-z])(?=.*\d)(?=.*[-./',;&@#*+"])[a-zA-Z\d-./',;&@#*+"]{8,}$/,
                    VinValidation: /^[a-zA-Z0-9]{17}$/,
                    HtmlInjectionValidation: /[<>]/g,

                },
                ErrorCodes: {
                    UnknownError: 'UnknownError',
                    SessionExpired: 'SessionExpired',
                    AuthenticationFailed: 'AuthenticationFailed',
                    InvalidUsernameOrPassword: 'InvalidUsernameOrPassword',
                },
                ReactableDefaultItemsPerPage: 10,
                ReactablePageButtonLimit: 10,
                UsageTextType: {
                    Header: 0,
                    BeforeUsageDef: 1,
                    AfterUsageDef: 2,
                    Popup: 3,
                    Footer: 4,
                },
                // VehicleChartMethods: {
                //     GetVehicleDataByVehicleId: 'GetVehicleDataByVehicleId',
                //     GetVehicleLastVisitsByVehicleId: 'GetVehicleLastVisitsByVehicleId',
                //     GetVehicleMaintenanceContractsByVehicleId: 'GetVehicleMaintenanceContractsByVehicleId',
                //     GetVehicleSRPByVehicleId: 'GetVehicleSRPByVehicleId',
                //     GetVehicleTechnicalCampaignsByVehicleId: 'GetVehicleTechnicalCampaignsByVehicleId',
                //     GetVehiclePUMACasesByVehicleId: 'GetVehiclePUMACasesByVehicleId',
                //     GetVehicleTeleServicesByVehicleId: 'GetVehicleTeleServicesByVehicleId',
                // },
                // ReportTypes: {
                //     ReportGeral: ReportGeralConst,
                //     ReportTSP: ReportTSPConst,
                //     ReportCIC: ReportCICConst,
                //     ReportAnalise: ReportAnaliseConst,
                // },
            },
            Validations: {
                FirstName: { MaxLength: 40 },
                LastName: { MaxLength: 40 },
                City: { MaxLength: 40 },
                AddressFloor: { MaxLength: 10 },
                AddressNumber: { MaxLength: 10 },
                AddressStreet: { MaxLength: 50 },
                PostalCode: { MaxLength: 10 },
                Nif: { MaxLength: 9 },
                PhoneNumber: { MaxLength: 30 },
                VIN: { MaxLength: 17 },
                LicensePlate: { MaxLength: 20 },
                LicensePlateForeign: { MaxLength: 20 },
            },

            // ReportTypeDefinitions: [
            //     {type: ReportGeralConst, title: 'Geral', apiAction: 'export-report-geral', fileExtension: 'xlsx'},
            //     {type: ReportTSPConst, title: 'TSP', apiAction: 'export-report-tsp', fileExtension: 'zip' },
            //     {type: ReportCICConst, title: 'CIC', apiAction: 'export-report-cic', fileExtension: 'xlsx' },
            //     {type: ReportAnaliseConst, title: 'Análise', apiAction: 'export-report-analise-ts', fileExtension: 'xlsx'},
            // ],
        },
        appEnvConfig,
    ),
    isDevAppEnv: DevAppEnvs.indexOf(envConfig.AppEnv) > -1,
};

registerLocale(config.DateLocale, pt);

export default config;
